import React from "react";

const AlertModal = ({ message, onClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div className="bg-white rounded-xl shadow-lg p-6 w-80">
        <h2 className="text-sm font-semibold text-gray-800 mb-6 text-center">
          {message}
        </h2>
        <div className="flex justify-center">
          <button
            onClick={onClose}
            className="px-4 py-1 bg-emerald-500 text-white rounded-lg hover:bg-emerald-600"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
